import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from '@apollo/client';
import { onError } from '@apollo/link-error'

const useAppApolloClient = () => {
  const parts = window.location.pathname.split('/');
  const token = parts[parts.length - 1];
  let baseUrl = `https://${window.location.host}/api`;

  const onErrorLink: any = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        ),
      );
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache'
      },
      query: {
        fetchPolicy: 'no-cache'
      },
      mutate: {
        fetchPolicy: 'no-cache'
      }
    },
    link: ApolloLink.from([
      onErrorLink,
      createHttpLink({
        uri: baseUrl,
        credentials: 'include',
        headers: {
          authorization: `Bearer ${token}`
        }
      })
    ])
  });
};

export default useAppApolloClient;
